
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <contact-edit *ngSwitchCase="true"></contact-edit>
            <contact-details *ngSwitchCase="false"></contact-details>
        </div>
    </ng-template>  
</main-form-modal>